export const basicModel1 = [
    { id: "Value 1", caption: "Label for the value 1" },
    {
        id: "Value 2",
        caption: "Label for the value 2"
    },
    {
        id: "Value 3",
        caption: "Label for the value 3",
        disabled: true
    },
    { id: "Value 4", caption: "Label for the value 4" }
];
export const model2 = [
    { id: "Value 1", caption: "Label for the value 1" },
    {
        id: "Value 2",
        caption: "Label for the value 2"
    },
    {
        id: "Value 3",
        caption: "Label for the value 3",
        disabled: true
    },
    { id: "Value 4", caption: "Label for the value 4" },
    {
        id: "Value 5",
        caption: "Label for the value 5",
        disabled: true
    },
    {
        id: "Value 6",
        caption: "Label for the value 6"
    },
    {
        id: "Value 7",
        caption: "Label for the value 7",
        disabled: true
    },
    { id: "Value 8", caption: "Label for the value 8" }
];
